<template>
    <Component v-if="currentPopup" :key="Date.now()" :is="currentPopup.component" v-bind="currentPopup.params" @close="closePopup" />
</template>

<script setup lang="ts">
import popupManager from '@/utils/PopupManager'
import Benefit from '@/components/dialog/benefit.vue'
import LoseReturn from '@/components/dialog/loseReturn.vue'
import BonusDialog from '@/components/dialog/bonusDialog.vue'
import ChargeGift from '@/components/dialog/chargeGift.vue'
import { useBaseStore } from '@/stores'
import eventBus, { EVENT_KEY } from '@/utils/bus'
import BindPhone from '@/components/dialog/BindDialog.vue'
import BindInviter from '@/components/dialog/BindInviter.vue'
import WelcomeSignup from '@/components/dialog/welcomeSignup.vue'
import { checkOrder } from '@/api/wallet/index'
import WelcomeGift from '@/components/dialog/welcomeGift.vue'
import GetBonus from '@/components/dialog/getBounus.vue'
import Sign from '@/components/dialog/sign.vue'
import Congratulations from '@/components/dialog/congratulations.vue'
import { useRoute } from 'vue-router'

const props = defineProps({
    type: {
        type: Number,
        default: () => 0,
    },
})

const store = useBaseStore()
const route = useRoute()

const eventMap = {
    paymentpresent: ChargeGift,
    benefit: Benefit,
    ladderloserebate: LoseReturn,
    '/bindPhone': BindPhone,
    '/bindInviter': BindInviter,
    congratulations: Congratulations,
    firstpayment: ChargeGift,
    onlinesign: Sign,
    reliefaward: Benefit,
}

const notLoginList = [WelcomeSignup]
//  BindPhone,
const loginList = [WelcomeGift, GetBonus, ChargeGift, Benefit, Sign]

const addQuee = () => {
    popupManager.clearQueue()
    let componentList = []
    if (!store.token) {
        componentList = [...notLoginList]
    } else {
        componentList = [...loginList]
    }
    componentList.forEach((component) => {
        if (component) {
            if (!popupManager.clickedStack.includes(component.__name)) {
                popupManager.addPopup(markRaw(component), {}, true)
            }
        }
    })
    popupManager.startCheck()
}

const currentPopup = popupManager.currentPopup

function closePopup() {
    // popupManager.closeCurrentPopup()
}
const handleClickEvents = (item) => {
    // if (item.param === 'triggerpayout' && store.entryList['triggerpayout'].data?.acticity?.status === 1) {
    //     item.param = 'triggerpayout1'
    // }
    const com = eventMap[item.param]
    const showIgnore = !popupManager.clickedStack.includes(com.__name)
    if (com || item.forceShow) {
        popupManager.insertPopup(markRaw(com), { type: item.type || 1, msg: item.msg, showIgnore, forceShow: item.forceShow || false })

        popupManager.checkQueue()
    }
}
const handleChargeFirst = (order) => {
    handleClickEvents({
        param: 'congratulations',
        msg: order.item,
        type: order.type,
        forceShow: true,
    })
    if (!Array.isArray(order.item) && order.item.usefor === 'firstpayment') {
        eventBus.emit('chargeGift', false)
    }
    if (route.path === '/') {
        eventBus.emit('checkBindDialog')
    }
}
const checkChargeFirst = () => {
    if (store.depositOrder) {
        checkOrder({
            uid: store.userInfo.uid,
            orderId: store.depositOrder,
        }).then((res) => {
            if (res.code === 200) {
                handleChargeFirst(res.info)
            }
        })
        store.depositOrder = ''
    }
}
const handleVisible = () => {
    if (document.visibilityState === 'visible') {
        // 页面变为可见状态时执行的操作
        checkChargeFirst()
    }
}
onActivated(() => {
    if (popupManager.queue.length) {
        popupManager.clearQueue()
    }
    if (props.type !== 0) {
        return
    }
    addQuee()
})
onBeforeMount(() => {
    eventBus.on('activity', handleClickEvents)
    eventBus.on(EVENT_KEY.PAYMENT, handleChargeFirst)
    if (props.type === 0) {
        // addQuee()
        window.addEventListener('visibilitychange', handleVisible)
        if (store.depositOrder) {
            checkChargeFirst()
        }
    }
})
onBeforeUnmount(() => {
    eventBus.off('activity', handleClickEvents)
    eventBus.off(EVENT_KEY.PAYMENT, handleChargeFirst)
    if (props.type === 0) {
        window.removeEventListener('visibilitychange', handleVisible)
    }
})
</script>

<style scoped></style>
